import PropTypes from 'prop-types';
import { useRef, forwardRef, useImperativeHandle } from 'react';
import { Card, CardContent} from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';
import ReadOnlyTextField from 'src/components/widgets/readonly-textfield';
import QuillEditor from 'src/components/quill-editor';
import AvatarDisplay from 'src/components/widgets/avatar-display';
import StringTextField from 'src/components/widgets/string-textfield';
import SubmitButton, { useCustomFormik } from 'src/components/formik-helper';
import { useTranslation } from 'react-i18next';
import { appStr } from 'src/locales/app_strings';
import {
  validationCourseSchema,
  handleCourseSubmitted,
} from './formik';

export const CourseView = forwardRef(({ item }, ref) => {
  const { t } = useTranslation();
  const editorRef = useRef();

  useImperativeHandle(ref, () => ({
    setDataFromParent: (value) => {
      console.log('==', value);
    },
  }));

  const formik = useCustomFormik({
    // initialValues: initialValues,
    validationSchema: validationCourseSchema(),
    onSubmit: async (values, helpers) => {
      await handleCourseSubmitted(values, apiUpdateCourse);
    },
  });

  return (
    <Card>
      <CardContent sx={{ px: 1, py: 2 }}>
        <Grid container spacing={3}>
          <Grid xs={12} md={9}>
            <><Grid container spacing={3}>
              <Grid xs={12} md={6}>
                <ReadOnlyTextField label="Họ tên" value={item.name} />
              </Grid>

              <Grid xs={6} md={3} sm={6}>
                <ReadOnlyTextField label="Số điện thoại" value={item.phone} enumType='phone'/>
              </Grid>

              <Grid xs={6} md={3} sm={6}>
                <ReadOnlyTextField label="Sinh nhật" value={item.birthday} />
              </Grid>

              <Grid xs={6} md={2} sm={6}>
                <ReadOnlyTextField label="Giới tính" value={item.genderLabel} />
              </Grid>

              <Grid xs={6} md={4} sm={6}>
                <ReadOnlyTextField label="Căn cước" value={item.identityCard} />
              </Grid>

              <Grid xs={6} md={2} sm={6}>
                <ReadOnlyTextField label={t(appStr.txt_073)} value={item.degreeName} />
              </Grid>

              <Grid xs={6} md={4} sm={6}>
                <ReadOnlyTextField label="Khóa học" value={item.courseName} />
              </Grid>

              <Grid xs={12} md={12}>
                <QuillEditor
                  ref={editorRef}
                  value={item.note}
                  isReadOnly={true}
                  sx={{ height: 130 }}
                />
              </Grid>

            </Grid>
            </>
          </Grid>
          <Grid xs={12} md={3}>
            <><Grid container spacing={3}>
                <Grid xs={12} md={12} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                  <AvatarDisplay avatar={item.avatar} gender={item.gender} />
                </Grid>
              </Grid>
            </>
          </Grid>

          <Grid xs={12} md={12} sx={{ mt: 2}}>
            <form onSubmit={formik.handleSubmit}>
              <Grid container spacing={3}>
                <Grid xs={12} md={3}>
                  <StringTextField label={t(appStr.txt_071)} name="firstCodeField" formik={formik} hintValue={item.firstCode} />
                </Grid>
                <Grid xs={12} md={3}>
                  <StringTextField label={t(appStr.txt_072)} name="secondCodeField" formik={formik} hintValue={item.secondCode} />
                </Grid>
                <Grid xs={12} md={5} display="flex" 
                  sx={{ justifyContent: { xs: 'center', md: 'flex-end' } }}
                >
                  <SubmitButton formik={formik} />
                </Grid>
              </Grid>
            </form>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
});

CourseView.propTypes = {
  item: PropTypes.object.isRequired,
  apiUpdate: PropTypes.func,
  apiDelete: PropTypes.func,
};